module.exports = __webpack_public_path__ + "fonts/KaTeX_SansSerif-Italic.e934cbc8.woff2";